import { render, staticRenderFns } from "./notificationSnack.vue?vue&type=template&id=64db8888&"
import script from "./notificationSnack.vue?vue&type=script&lang=js&"
export * from "./notificationSnack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports